import { Navigate, Outlet } from "react-router-dom";
import React, { FC } from "react";
import { cookies } from "../api";

interface IPublicRouteProps {
  restricted?: boolean;
  redirectTo?: string;
}

const PublicRoute: FC<IPublicRouteProps> = ({ restricted = false, redirectTo = "/" }) => {
  const isLogged =
    cookies.get("ciid_access_token") !== undefined && cookies.get("ciid_access_token").length;
  const shouldRedirect = isLogged && restricted;
  return <>{shouldRedirect ? <Navigate replace to={redirectTo} /> : <Outlet />}</>;
};

export default PublicRoute;
